var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHash = function SvgHash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.184 2.05a.6.6 0 0 1 .529.664l-.618 5.567h4.178a.6.6 0 0 1 0 1.2H15.96l-.559 5.034h4.87a.6.6 0 1 1 0 1.2H15.27l-.633 5.7a.6.6 0 0 1-1.194-.133l.62-5.567H9.035l-.633 5.7a.6.6 0 0 1-1.193-.133l.62-5.567h-4.18a.6.6 0 1 1 0-1.2h4.312l.56-5.035H3.649a.6.6 0 1 1 0-1.199h5.004l.634-5.7a.6.6 0 0 1 1.192.133L9.862 8.28h5.026l.633-5.7a.6.6 0 0 1 .664-.53M9.728 9.48l-.559 5.035h5.025l.56-5.035z"
  })));
};
export default SvgHash;